Vue.component("bi-modal",
    {
        template: "#vue-bi-modal",

        computed: {
            ...Vuex.mapState(
                {
                    modalData: state => state.assistant.biPlanModalData
                }
      ),
            ...Vuex.mapGetters(
                {
                    trans: "getTranslation"
                }
      )
        },

        methods: {
        }
    });
